import { gatewaySectorWorkFlows } from "../../../../../../../../gateways/gatewaySectorWorkFlows";

export const getAreas = async ({ categoryUid, squareFt, typeOfServiceUid, page = 1, pageSize = 30 } = {}) => {
  const params = new URLSearchParams();

  params.set("pageSize", String(pageSize));
  params.set("page", String(page));

  if (categoryUid != null && categoryUid !== "") params.set("category", String(categoryUid));
  if (squareFt != null && squareFt !== "") params.set("squareFootage", String(squareFt));
  if (typeOfServiceUid != null && typeOfServiceUid !== "") params.set("typeOfService", String(typeOfServiceUid));

  const qs = params.toString();
  const url = qs ? `/areas?${qs}` : "/areas";

  const res = await gatewaySectorWorkFlows.get(url);
  return res.data?.data || res.data;
};

// This is just a temporal fix, the table areas_by_square_footage is not working as expected
// The table appeared empty on the dump, so I'm using the areas table for nows
